import { render, staticRenderFns } from "./quick-order-remark.vue?vue&type=template&id=cda4a5a0&scoped=true&"
import script from "./quick-order-remark.vue?vue&type=script&lang=js&"
export * from "./quick-order-remark.vue?vue&type=script&lang=js&"
import style0 from "./quick-order-remark.vue?vue&type=style&index=0&id=cda4a5a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cda4a5a0",
  null
  
)

export default component.exports